import { ref } from 'vue'

export default function useUiEvent(open: () => void) {
  const isBlured = ref(false)
  const isFocused = ref(false)

  function handleFocus() {
    isBlured.value = false
    isFocused.value = true
  }

  function handleBlur() {
    isBlured.value = true
    isFocused.value = false
  }

  function handleKeydown(event: KeyboardEvent) {
    if (['Space', 'Enter', 'NumpadEnter'].includes(event.code)) {
      event.preventDefault()
      open()
    }
  }

  return {
    isBlured,
    isFocused,
    handleFocus,
    handleBlur,
    handleKeydown,
  }
}
